import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {

  connect() {
    App.Helpers.listenToCustomEvent(document, "update-success", this.reloadTable.bind(this));
    document.dispatchEvent(createCustomEvent("table-refresh", this.element, {rows: this.rowCount}))
  }

  reloadTable() {
    if (this.tableURL) {
      document.dispatchEvent(createCustomEvent("form-cancel", this.element));
      App.Helpers.ajaxRequest({url: this.tableURL, method: "GET", successHandler: this.replaceTable.bind(this)});
    }
  }

  replaceTable(res) {
    App.Helpers.replaceElement(this.element, res);
  }

  deleteActivity(event) {
    event.preventDefault();
    const link = event.target;
    if (confirm('Are you sure?')) {
      App.Helpers.ajaxRequest({
        url:            link.href,
        method:         'DELETE',
        data:           { _method: 'delete' },
        successHandler: this.reloadTable.bind(this)
      });
    }
  }

  openEditForm(event) {
    event.preventDefault();
    const link = event.target;
    App.Helpers.ajaxRequest({
      url: link.href,
      method: 'GET',
      successHandler: this.remoteFormHandler.bind(this)
    });
  }

  remoteFormHandler(res) {
    App.Modal.open({ content: `<div data-controller="modal-form" data-modal-form-element-content-from-server="true">${res}</div>` });
  }

  //
  // GETTERS AND SETTERS
  //

  get tableURL() {
    return this.data.get("table-url");
  }

  get orderUpdateURL() {
    return this.data.get("order-update-url");
  }

  get rowCount() {
    return [...this.element.querySelectorAll("tbody tr")].length;
  }
};



// WEBPACK FOOTER //
// ./app/components/briefs/assets/javascript/briefs-brief-edit-table-controller.js